<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="container ml-10">
      <h1>System Settings</h1>
      <div class="row">
        <div class="col-md-12 border mt-5 custom-card">
          <div class="row mt-2 mb-3 caption">
            <div class="col-md-5">
              Settings Name
            </div>
            <div class="col-md-5">
              Value
            </div>
            <div class="col-md-2 text-break">
              Portal Visibility
            </div>
          </div>
          <hr/>
          <div v-for="system_setting in system_settings" :key="system_setting.system_key" class="row mb-2">
            <!--            system key-->
            <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
              <label :title="system_setting.system_key">{{
                  system_setting.system_key.split('_').map(word => word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase()).join(' ')
                }}</label>
            </div>
            <div class="col-md-1 col-sm-1 mt-2">
              <label><b>:</b></label>
            </div>
            <div v-if="system_setting.value !== 'Y' && system_setting.value !== 'N'"
                 class="col-md-5 col-sm-4 mt-2">
              <input v-model="system_setting.value" :style="{
                  'background': system_setting.portal_yn === 'N' ? '#fdf6ee' : '#fff',
                  'color': system_setting.portal_yn === 'N' ? '#000' : '#000',
                  'font-weight': system_setting.portal_yn === 'N' ? 'bold' : 'normal'
                }" :title="system_setting.value"
                     class="form-control" type="text"
                     @input="onInputChange(system_setting)" @keyup.enter="saveSystemSettings(system_setting)">
            </div>
            <!--            value-->
            <div v-else class="col-md-5 col-sm-4 mt-2">
              <select v-model="system_setting.value"
                      :style="system_setting.value === 'Y' ? 'background: #5cb85c; color: #fff;' : 'background: #d9534f; color: #fff;'"
                      :title="system_setting.value"
                      :value="system_setting.value" class="form-control"
                      style="width: 25%; text-align: center;"
                      @change="saveSystemSettings(system_setting)" @input="onInputChange(system_setting)">
                <option value="Y"><b>Yes</b></option>
                <option value="N"><b>No</b></option>
              </select>
            </div>
            <!--            portal visibilty-->
            <div class="col-md-1 col-sm-2 mt-2 text-end">
              <div class="form-check form-switch">
                <input :id="system_setting.system_key" v-model="system_setting.toggleValue" class="form-check-input"
                       role="switch"
                       style="transform: scale(1.8);" type="checkbox"
                       @change="saveSystemSettings(system_setting)">
              </div>
            </div>
            <div v-if="system_setting.isChanged" class="col-md-1 col-sm-2 mt-2">
              <button class="btn btn-primary" title="Save" @click="saveSystemSettings(system_setting)">
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 border mt-3 mb-3 custom-card">
          <button class="btn btn-primary mt-3 mb-3" title="Add More" @click="addMore = true">
            <i class="fa fa-plus"></i> Add More
          </button>
          <div v-if="addMore === true" class="row mb-2">
            <div class="col-md-4 mt-2">
              <input v-model="newSystemSetting.system_key" class="form-control" placeholder="Enter system_key"
                     type="text">
            </div>
            <div class="col-md-1 mt-2">
              <label><b>:</b></label>
            </div>
            <div class="col-md-5 mt-2">
              <input v-model="newSystemSetting.value" class="form-control" placeholder="Enter Value" type="text">
            </div>
            <div class="col-md-1 mt-2">
              <select v-model="newSystemSetting.portal_yn" :value="newSystemSetting.portal_yn" class="form-control"
                      style="width: 100%; text-align: center;">
                <option value="Y"><b>Yes</b></option>
                <option value="N"><b>No</b></option>
              </select>
            </div>
            <div class="col-md-1 mt-2">
              <button class="btn btn-primary" title="Save" @click="saveSystemSettings(newSystemSetting)">
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SystemSettingsService from "@/services/system-settings.service";

export default {
  name: "SystemSettings",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Settings',
          href: '#',
        },
      ],
      newSystemSetting: {
        system_key: null,
        value: null,
        portal_yn: 'Y',
      },
      addMore: false,
      system_settings: [],
    };
  },
  methods: {
    async getSystemSettings() {
      try {
        const response = await SystemSettingsService.getSystemSettingsOnly();
        if (response.data) {
          const text_editor_token_obj = response.data.find(item => item.system_key === "text_editor_token");
          const token = text_editor_token_obj ? text_editor_token_obj.value : null;
          const carrer_api_url_obj = response.data.find(item => item.system_key === "carrer_api_url");
          const carrer_api_url = carrer_api_url_obj ? carrer_api_url_obj.value : null;
          localStorage.setItem('text_editor_token', token);
          localStorage.setItem('carrer_api_url', carrer_api_url);

          this.system_settings = response.data.map(setting => ({
            ...setting,
            originalValue: setting.value,
            isChanged: false,
            toggleValue: setting.portal_yn == 'Y' ? true : false,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    onInputChange(system_setting) {
      // Check if the value has changed
      system_setting.isChanged = system_setting.value !== system_setting.originalValue;
    },
    async saveSystemSettings(system_setting) {
      try {
        // Your save logic here
        if (system_setting.toggleValue == true) {
          system_setting.portal_yn = 'Y';
        } else {
          system_setting.portal_yn = 'N';
        }
        const response = await SystemSettingsService.saveSystemSettings(system_setting);
        if (response.data) {
          if (response.data.messageCode === 1) {
            this.showNotification('success', response.data.message);
            system_setting.originalValue = system_setting.value;
            system_setting.isChanged = false;
            if (this.addMore === true) {
              this.addMore = false;
              this.newSystemSetting.system_key = null;
              this.newSystemSetting.value = null;
              await this.getSystemSettings();
            }
          } else {
            this.showNotification('error', response.data.message);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'System Settings',
        text: message,
      });
    },
  },
  mounted() {
    this.getSystemSettings();
  },
};
</script>

<style scoped>
.custom-card {
  background: #ffffff;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
}

.caption {
  font-size: 20px;
  font-weight: 500;
}
</style>